/*eslint-disable*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  pauth: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PAuth"
    },
    nested: {
      PbSignUpRequest: {
        fields: {
          email: {
            type: "string",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          password: {
            type: "string",
            id: 4
          },
          mobile: {
            type: "string",
            id: 5
          }
        }
      },
      PbLoginRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          password: {
            type: "string",
            id: 2
          }
        }
      },
      PbLoginResponse: {
        fields: {
          accessToken: {
            type: "string",
            id: 1
          },
          refreshToken: {
            type: "string",
            id: 2
          }
        }
      },
      PbCodeRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          type: {
            type: "uint32",
            id: 2
          },
          to: {
            type: "string",
            id: 3
          }
        }
      },
      PbCodeResponse: {
        fields: {
          to: {
            type: "string",
            id: 1
          }
        }
      },
      PbConfirmRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          type: {
            type: "uint32",
            id: 2
          },
          code: {
            type: "string",
            id: 3
          }
        }
      },
      PbTokenRequest: {
        fields: {
          refreshToken: {
            type: "string",
            id: 2
          }
        }
      },
      PbTokenResponse: {
        fields: {
          accessToken: {
            type: "string",
            id: 1
          }
        }
      },
      PbCheckRequest: {
        fields: {
          value: {
            type: "string",
            id: 1
          },
          type: {
            type: "string",
            id: 2
          },
          userId: {
            type: "uint64",
            id: 3
          }
        }
      },
      PbFindAccountRequest: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          }
        }
      },
      PbFindAccountResponse: {
        fields: {
          email: {
            type: "string",
            id: 1
          }
        }
      },
      PbEmailConfirmRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          token: {
            type: "string",
            id: 2
          }
        }
      },
      PbChangePasswordRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          type: {
            type: "uint32",
            id: 2
          },
          code: {
            type: "string",
            id: 3
          },
          password: {
            type: "string",
            id: 4
          }
        }
      },
      PbCheckPasswordRequest: {
        fields: {
          password: {
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  pcar: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PCar"
    },
    nested: {
      PbCar: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          vin: {
            type: "string",
            id: 2
          },
          plateNo: {
            type: "string",
            id: 3
          }
        }
      },
      PbCompanyCreateRequest: {
        fields: {
          car: {
            type: "PbCar",
            id: 1
          }
        }
      },
      PbCarList: {
        fields: {
          car: {
            rule: "repeated",
            type: "PbCar",
            id: 1
          }
        }
      }
    }
  },
  pcommon: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PCommon"
    },
    nested: {
      PbError: {
        fields: {
          data: {
            type: "bytes",
            id: 1
          },
          code: {
            type: "int64",
            id: 2
          },
          message: {
            type: "string",
            id: 3
          }
        }
      },
      PbBase: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          createdAt: {
            type: "string",
            id: 100
          },
          updatedAt: {
            type: "string",
            id: 101
          },
          createdBy: {
            type: "uint64",
            id: 102
          },
          updatedBy: {
            type: "uint64",
            id: 103
          }
        }
      },
      PbPageable: {
        fields: {
          total: {
            type: "uint64",
            id: 1
          },
          page: {
            type: "uint32",
            id: 2
          },
          current: {
            type: "uint32",
            id: 3
          },
          size: {
            type: "uint32",
            id: 4
          }
        }
      },
      PbSearchParam: {
        fields: {
          keyword: {
            type: "string",
            id: 1
          },
          from: {
            type: "string",
            id: 2
          },
          to: {
            type: "string",
            id: 3
          }
        }
      },
      PbImage: {
        fields: {
          data: {
            type: "string",
            id: 1
          },
          ext: {
            type: "string",
            id: 2
          },
          width: {
            type: "float",
            id: 3
          },
          height: {
            type: "float",
            id: 4
          }
        }
      },
      PbFile: {
        fields: {
          type: {
            type: "string",
            id: 1
          },
          data: {
            type: "bytes",
            id: 3
          },
          ext: {
            type: "string",
            id: 4
          }
        }
      }
    }
  },
  pcompany: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PCompany"
    },
    nested: {
      PbCompany: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          corporationNo: {
            type: "string",
            id: 3
          },
          businessNo: {
            type: "string",
            id: 4
          },
          representative: {
            type: "string",
            id: 5
          },
          statusCode: {
            type: "uint32",
            id: 6
          },
          statusName: {
            type: "string",
            id: 7
          },
          postcode: {
            type: "string",
            id: 11
          },
          addr1: {
            type: "string",
            id: 12
          },
          addr2: {
            type: "string",
            id: 13
          },
          licenseFileName: {
            type: "string",
            id: 21
          },
          licenseFileOrgName: {
            type: "string",
            id: 22
          },
          stampFileName: {
            type: "string",
            id: 23
          },
          stampFileOrgName: {
            type: "string",
            id: 24
          },
          file: {
            rule: "repeated",
            type: "pcommon.PbFile",
            id: 100
          }
        }
      },
      PbCompanyBranch: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          businessNo: {
            type: "string",
            id: 3
          }
        }
      },
      PbCompanyCar: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          plateNo: {
            type: "string",
            id: 3
          },
          statusCode: {
            type: "uint32",
            id: 4
          },
          statusName: {
            type: "string",
            id: 5
          }
        }
      },
      PbCompanyUser: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          userId: {
            type: "uint64",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          email: {
            type: "string",
            id: 5
          },
          typeCode: {
            type: "uint32",
            id: 6
          },
          typeName: {
            type: "string",
            id: 7
          },
          statusCode: {
            type: "uint32",
            id: 8
          },
          statusName: {
            type: "string",
            id: 9
          }
        }
      },
      PbCompanyPoint: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          status: {
            type: "uint32",
            id: 3
          },
          point: {
            type: "double",
            id: 4
          },
          expiredAt: {
            type: "string",
            id: 5
          },
          originId: {
            type: "uint64",
            id: 6
          },
          companyOrderId: {
            type: "uint64",
            id: 7
          },
          solutionHistoryId: {
            type: "uint64",
            id: 8
          }
        }
      },
      PbCompanyExternal: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          userId: {
            type: "string",
            id: 2
          },
          userPassword: {
            type: "string",
            id: 3
          },
          typeCode: {
            type: "uint32",
            id: 4
          },
          typeName: {
            type: "string",
            id: 5
          },
          statusCode: {
            type: "uint32",
            id: 6
          },
          statusName: {
            type: "string",
            id: 7
          }
        }
      },
      PbCompanyExternalList: {
        fields: {
          companyExternal: {
            rule: "repeated",
            type: "PbCompanyExternal",
            id: 1
          }
        }
      },
      PbCompanyCreateRequest: {
        fields: {
          company: {
            type: "PbCompany",
            id: 1
          }
        }
      },
      PbCompanyCheckRequest: {
        fields: {
          type: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          }
        }
      },
      PbCompanyJoinRequest: {
        fields: {
          companyId: {
            type: "uint64",
            id: 1
          }
        }
      },
      PbCompanyList: {
        fields: {
          company: {
            rule: "repeated",
            type: "PbCompany",
            id: 1
          }
        }
      },
      PbCompanyCarList: {
        fields: {
          car: {
            rule: "repeated",
            type: "PbCompanyCar",
            id: 1
          },
          pageable: {
            type: "pcommon.PbPageable",
            id: 10
          }
        }
      },
      PbCompanyCarCreateRequest: {
        fields: {
          car: {
            rule: "repeated",
            type: "PbCompanyCar",
            id: 1
          }
        }
      },
      PbCompanyUserList: {
        fields: {
          user: {
            rule: "repeated",
            type: "PbCompanyUser",
            id: 1
          },
          pageable: {
            type: "pcommon.PbPageable",
            id: 10
          }
        }
      },
      PbCompanyUserCreateRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          password: {
            type: "string",
            id: 3
          },
          mobile: {
            type: "string",
            id: 4
          }
        }
      },
      PbCompanyUserApproveRequest: {
        fields: {
          companyId: {
            type: "uint64",
            id: 1
          },
          userId: {
            rule: "repeated",
            type: "uint64",
            id: 2
          }
        }
      },
      PbCompanyUserResetRequest: {
        fields: {
          companyId: {
            type: "uint64",
            id: 1
          },
          userId: {
            type: "uint64",
            id: 2
          }
        }
      },
      PbCompanySolution: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          solutionId: {
            type: "uint64",
            id: 3
          }
        }
      },
      PbCompanySolutionList: {
        fields: {
          solution: {
            rule: "repeated",
            type: "PbCompanySolution",
            id: 1
          }
        }
      }
    }
  },
  pcontract: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PContract"
    },
    nested: {
      PbContract: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          companyCarId: {
            type: "uint64",
            id: 3
          },
          plateNo: {
            type: "string",
            id: 4
          },
          no: {
            type: "string",
            id: 5
          },
          type: {
            type: "uint32",
            id: 6
          },
          typeName: {
            type: "string",
            id: 7
          },
          contractAt: {
            type: "string",
            id: 8
          },
          startAt: {
            type: "string",
            id: 9
          },
          dueAt: {
            type: "string",
            id: 10
          },
          endAt: {
            type: "string",
            id: 11
          },
          totalAmount: {
            type: "uint32",
            id: 12
          },
          paidAmount: {
            type: "uint32",
            id: 13
          },
          unpaidAmount: {
            type: "uint32",
            id: 14
          },
          cdw: {
            type: "uint32",
            id: 15
          },
          cdwAmount: {
            type: "uint32",
            id: 16
          },
          status: {
            type: "uint32",
            id: 17
          },
          statusName: {
            type: "string",
            id: 18
          },
          form: {
            type: "string",
            id: 19
          },
          user: {
            rule: "repeated",
            type: "PbContractUser",
            id: 20
          }
        }
      },
      PbContractUser: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          contractId: {
            type: "uint64",
            id: 2
          },
          userType: {
            type: "uint32",
            id: 3
          },
          userTypeName: {
            type: "string",
            id: 4
          },
          registrationNo: {
            type: "string",
            id: 5
          },
          name: {
            type: "string",
            id: 6
          },
          contact: {
            type: "string",
            id: 7
          },
          addr1: {
            type: "string",
            id: 8
          },
          addr2: {
            type: "string",
            id: 9
          },
          postcode: {
            type: "string",
            id: 10
          },
          driverLicenseNo: {
            type: "string",
            id: 11
          },
          driverLicenseType: {
            type: "uint32",
            id: 12
          },
          driverLicenseTypeName: {
            type: "string",
            id: 13
          }
        }
      },
      PbContractCreateRequest: {
        fields: {
          contract: {
            rule: "repeated",
            type: "PbContract",
            id: 1
          }
        }
      },
      PbContractList: {
        fields: {
          contract: {
            rule: "repeated",
            type: "PbContract",
            id: 1
          },
          pageable: {
            type: "pcommon.PbPageable",
            id: 10
          }
        }
      }
    }
  },
  presource: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PResource"
    },
    nested: {
      PbDescription: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          type: {
            type: "string",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          label: {
            type: "string",
            id: 5
          }
        }
      },
      PbResource: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          descriptionId: {
            type: "uint64",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          metadata: {
            rule: "repeated",
            type: "PbResourceMetadata",
            id: 5
          },
          tag: {
            rule: "repeated",
            type: "string",
            id: 10
          }
        }
      },
      PbResourceMetadata: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          value: {
            type: "string",
            id: 3
          }
        }
      },
      PbAction: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          resourceId: {
            type: "uint64",
            id: 2
          },
          companyUserId: {
            type: "uint64",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          at: {
            type: "string",
            id: 5
          },
          amount: {
            type: "double",
            id: 6
          },
          comment: {
            type: "string",
            id: 7
          },
          tag: {
            rule: "repeated",
            type: "string",
            id: 10
          }
        }
      },
      PbActionType: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          }
        }
      },
      PbDescriptionItem: {
        fields: {
          description: {
            type: "PbDescription",
            id: 1
          },
          children: {
            rule: "repeated",
            type: "PbDescription",
            id: 2
          }
        }
      },
      PbDescriptionItemList: {
        fields: {
          item: {
            rule: "repeated",
            type: "PbDescriptionItem",
            id: 1
          }
        }
      }
    }
  },
  psolution: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PSolution"
    },
    nested: {
      PbSolution: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          item: {
            rule: "repeated",
            type: "PbSolutionItem",
            id: 10
          }
        }
      },
      PbSolutionItem: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          price: {
            rule: "repeated",
            type: "PbSolutionPrice",
            id: 10
          }
        }
      },
      PbSolutionPrice: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          cash: {
            type: "double",
            id: 2
          },
          point: {
            type: "double",
            id: 3
          },
          startAt: {
            type: "string",
            id: 4
          },
          endAt: {
            type: "string",
            id: 5
          }
        }
      },
      PbSolutionDiscount: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          solutionItemId: {
            type: "uint64",
            id: 3
          },
          type: {
            type: "int32",
            id: 4
          },
          status: {
            type: "int32",
            id: 5
          },
          startAt: {
            type: "string",
            id: 6
          },
          endAt: {
            type: "string",
            id: 7
          }
        }
      },
      PbSolutionHistory: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          company: {
            type: "pcompany.PbCompany",
            id: 2
          },
          solutionItem: {
            type: "PbSolutionItem",
            id: 3
          },
          solutionPriceId: {
            type: "uint64",
            id: 4
          },
          solutionDiscountId: {
            type: "uint64",
            id: 5
          },
          status: {
            type: "int32",
            id: 6
          },
          price: {
            type: "double",
            id: 7
          },
          point: {
            type: "double",
            id: 8
          },
          solutionPaymentId: {
            type: "uint64",
            id: 9
          }
        }
      },
      PbSolutionList: {
        fields: {
          solution: {
            rule: "repeated",
            type: "PbSolution",
            id: 1
          }
        }
      },
      PbMonthlySolutionHistory: {
        fields: {
          historyDate: {
            type: "string",
            id: 1
          },
          ocrAmount: {
            type: "double",
            id: 2
          },
          rpaAmount: {
            type: "double",
            id: 3
          },
          faxAmount: {
            type: "double",
            id: 4
          },
          totalAmount: {
            type: "double",
            id: 5
          }
        }
      },
      PbMonthlySolutionHistoryList: {
        fields: {
          history: {
            rule: "repeated",
            type: "PbMonthlySolutionHistory",
            id: 1
          }
        }
      },
      PbSolutionChangeStatusRequest: {
        fields: {
          companyId: {
            type: "uint64",
            id: 1
          },
          solutionId: {
            type: "uint64",
            id: 2
          }
        }
      }
    }
  },
  ptax: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PTax"
    },
    nested: {
      PbTaxNotice: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          status: {
            type: "uint32",
            id: 3
          },
          type: {
            type: "uint32",
            id: 4
          },
          recognizeStatus: {
            type: "int32",
            id: 5
          },
          matchOrgStatus: {
            type: "int32",
            id: 6
          },
          searchContactStatus: {
            type: "int32",
            id: 7
          },
          requestStatus: {
            type: "int32",
            id: 8
          },
          plateNo: {
            type: "string",
            id: 9
          },
          sender: {
            type: "string",
            id: 10
          },
          receiver: {
            type: "string",
            id: 11
          },
          docNo: {
            type: "string",
            id: 12
          },
          details: {
            type: "string",
            id: 13
          },
          fileName: {
            type: "string",
            id: 14
          },
          fileExt: {
            type: "string",
            id: 15
          },
          fileOrgName: {
            type: "string",
            id: 16
          },
          changeFileName: {
            type: "string",
            id: 17
          },
          changeFileExt: {
            type: "string",
            id: 18
          },
          changeFileOrgName: {
            type: "string",
            id: 19
          },
          contractFileName: {
            type: "string",
            id: 20
          },
          contractFileExt: {
            type: "string",
            id: 21
          },
          contractFileOrgName: {
            type: "string",
            id: 22
          },
          label: {
            type: "string",
            id: 23
          },
          violation: {
            rule: "repeated",
            type: "PbTaxNoticeViolation",
            id: 30
          },
          car: {
            type: "pcompany.PbCompanyCar",
            id: 40
          },
          contract: {
            type: "pcontract.PbContract",
            id: 45
          },
          user: {
            type: "pcontract.PbContractUser",
            id: 50
          },
          contact: {
            type: "PbTaxContact",
            id: 55
          },
          changeRequest: {
            rule: "repeated",
            type: "PbTaxChangeRequest",
            id: 60
          }
        }
      },
      PbTaxNoticeViolation: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          objectionItemId: {
            type: "uint64",
            id: 2
          },
          violationAt: {
            type: "string",
            id: 3
          },
          location: {
            type: "string",
            id: 4
          },
          contractId: {
            type: "uint64",
            id: 5
          },
          details: {
            type: "string",
            id: 6
          }
        }
      },
      PbTaxNoticeSearchParam: {
        fields: {
          searchParam: {
            type: "pcommon.PbSearchParam",
            id: 1
          },
          type: {
            type: "uint32",
            id: 2
          }
        }
      },
      PbTaxChangeRequest: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          taxNoticeId: {
            type: "uint64",
            id: 2
          },
          typeCode: {
            type: "uint32",
            id: 3
          },
          typeName: {
            type: "string",
            id: 4
          },
          statusCode: {
            type: "uint32",
            id: 5
          },
          statusName: {
            type: "string",
            id: 6
          },
          taxNotice: {
            type: "PbTaxNotice",
            id: 10
          }
        }
      },
      PbTaxChangeRequestList: {
        fields: {
          request: {
            rule: "repeated",
            type: "PbTaxChangeRequest",
            id: 1
          },
          pageable: {
            type: "pcommon.PbPageable",
            id: 2
          }
        }
      },
      PbTaxNoticeResult: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          taxNotice: {
            type: "PbTaxNotice",
            id: 2
          }
        }
      },
      PbTaxNoticeResultList: {
        fields: {
          result: {
            rule: "repeated",
            type: "PbTaxNoticeResult",
            id: 1
          },
          pageable: {
            type: "pcommon.PbPageable",
            id: 10
          }
        }
      },
      PbTaxNoticeCreateRequest: {
        fields: {
          companyId: {
            type: "uint64",
            id: 1
          },
          file: {
            rule: "repeated",
            type: "pcommon.PbFile",
            id: 2
          }
        }
      },
      PbTaxNoticeList: {
        fields: {
          taxNotice: {
            rule: "repeated",
            type: "PbTaxNotice",
            id: 1
          },
          pageable: {
            type: "pcommon.PbPageable",
            id: 10
          }
        }
      },
      PbTaxNoticeRecognizeRequest: {
        fields: {
          taxNoticeId: {
            type: "uint64",
            id: 1
          }
        }
      },
      PbTaxNoticeSearchRequest: {
        fields: {
          taxNoticeId: {
            type: "uint64",
            id: 1
          }
        }
      },
      PbTaxNoticeSendRequest: {
        fields: {
          taxNoticeId: {
            rule: "repeated",
            type: "uint64",
            id: 1
          }
        }
      },
      PbTaxNoticeFaxResendRequest: {
        fields: {
          taxNoticeId: {
            type: "uint64",
            id: 1
          }
        }
      },
      PbTaxNoticeFaxRefundRequest: {
        fields: {
          taxNoticeId: {
            type: "uint64",
            id: 1
          }
        }
      },
      PbTaxContact: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          companyId: {
            type: "uint64",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          fax: {
            type: "string",
            id: 4
          },
          org: {
            type: "string",
            id: 5
          },
          tel: {
            type: "string",
            id: 6
          },
          comment: {
            type: "string",
            id: 7
          },
          keyword: {
            rule: "repeated",
            type: "string",
            id: 10
          }
        }
      },
      PbTaxContactList: {
        fields: {
          contact: {
            rule: "repeated",
            type: "PbTaxContact",
            id: 1
          }
        }
      },
      PbTaxContractUploadRequest: {
        fields: {
          taxNoticeId: {
            type: "uint64",
            id: 1
          },
          file: {
            rule: "repeated",
            type: "pcommon.PbFile",
            id: 2
          }
        }
      }
    }
  },
  puser: {
    options: {
      java_package: "kr.co.pincar.proto",
      java_outer_classname: "PUser"
    },
    nested: {
      PbUser: {
        fields: {
          base: {
            type: "pcommon.PbBase",
            id: 1
          },
          account: {
            type: "string",
            id: 2
          },
          email: {
            type: "string",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          role: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          companyUser: {
            rule: "repeated",
            type: "pcompany.PbCompanyUser",
            id: 6
          },
          company: {
            rule: "repeated",
            type: "pcompany.PbCompany",
            id: 7
          },
          loggedInAt: {
            type: "string",
            id: 10
          }
        }
      },
      PbUserPasswordChangeRequest: {
        fields: {
          oldPassword: {
            type: "string",
            id: 1
          },
          newPassword: {
            type: "string",
            id: 2
          }
        }
      }
    }
  }
});

export { $root as default };
